module.exports = __webpack_public_path__ + "static/seville-history-4-3d110e63395e2e42e517e0e181166bf1.jpeg";